import { gql } from '@apollo/client'
import { Collection } from '~/domain/Collection'
import { Vault } from '~/domain/Vault'
import { VaultCreatedEvent, subgraphQuery } from '~/services/graphql/vault'

export type VaultWithOriginalTokenId = Vault & { tokenId: string }

export const findVaultsInCollection = async (collection: Collection): Promise<VaultWithOriginalTokenId[]> => {
  const query = gql`
    query GetVaults($nftAddress: String!) {
      fragmentsVaultCreateds (where: { nftAddress: $nftAddress }) {
        creator,
        nftAddress,
        nftId,
        vaultAddress,
        fragments,
        royaltyBps
      }
    }
  `

  const events = await subgraphQuery({
    query,
    variables: { nftAddress: collection.contract.address.toLowerCase() },
  })

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return events.map((event: VaultCreatedEvent) => {
    return {
      seriesId: collection.seriesId,
      type: 'trophy',
      contract: {
        chainId: collection.contract.chainId,
        address: event.vaultAddress,
        standard: 'ERC721',
        fee: event.royaltyBps / 100,
      },
      creator: event.creator,
      fragments: event.fragments,
      tokenId: event.nftId,
      isDrop: event.isDrop,
    }
  })
}
